import { useState } from "react";
import { MessagesSquare } from "lucide-react";
import { Button } from "../../components/ui/button";
import { useApi } from "../../lib/useApi";
import { Loader, ErrorState, EmptyState, PageHeader } from "../../components/common/States";
import { StatusBadge, TypeBadge, SentimentBadge, Stars } from "../../components/common/Badges";
import { STATUS, TYPE, fmtDate } from "../../lib/labels";

export default function AdminFeedbacks() {
  const [f, setF] = useState({ company_id: "", type: "", status: "", page: 1 });
  const companies = useApi("/admin/companies");
  const qs = new URLSearchParams(Object.entries(f).filter(([, v]) => v !== "")).toString();
  const { data, loading, error, reload } = useApi(`/admin/feedbacks?${qs}`);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value, page: 1 });

  return (
    <div>
      <PageHeader title="Feedbacks réseau" description="Supervision en lecture seule de l'ensemble des feedbacks (coordonnées des usagers masquées)." />
      <div className="mb-6 flex flex-col gap-2 sm:flex-row">
        <select className="field-select" value={f.company_id} onChange={set("company_id")} data-testid="admin-feedbacks-company-filter">
          <option value="">Toutes les entreprises</option>
          {(companies.data || []).map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
        <select className="field-select sm:w-44" value={f.type} onChange={set("type")} data-testid="admin-feedbacks-type-filter">
          <option value="">Tous types</option>{Object.entries(TYPE).map(([k, t]) => <option key={k} value={k}>{t.label}</option>)}
        </select>
        <select className="field-select sm:w-44" value={f.status} onChange={set("status")} data-testid="admin-feedbacks-status-filter">
          <option value="">Tous statuts</option>{Object.entries(STATUS).map(([k, t]) => <option key={k} value={k}>{t.label}</option>)}
        </select>
      </div>
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && !data.items.length && <EmptyState icon={MessagesSquare} title="Aucun feedback" />}
      {data && data.items.length > 0 && (
        <>
          <div className="card-surface divide-y">
            {data.items.map((fb) => (
              <div key={fb.id} className="px-5 py-4" data-testid={`admin-feedback-row-${fb.id}`}>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-medium">{fb.company_name}</span><TypeBadge value={fb.type} /><StatusBadge value={fb.status} />
                  {fb.ai && <SentimentBadge value={fb.ai.sentiment} />}<Stars value={fb.rating} />
                  <span className="ml-auto text-xs text-slate-400">{fmtDate(fb.created_at)}</span>
                </div>
                <p className="mt-2 line-clamp-2 text-sm text-slate-600">{fb.message}</p>
              </div>
            ))}
          </div>
          <div className="mt-4 flex items-center justify-between text-sm text-slate-500">
            <span>{data.total} feedback(s)</span>
            <div className="flex items-center gap-2">
              <Button variant="outline" size="sm" disabled={data.page <= 1} onClick={() => setF({ ...f, page: f.page - 1 })} data-testid="admin-feedbacks-prev">Précédent</Button>
              <span>{data.page} / {data.pages}</span>
              <Button variant="outline" size="sm" disabled={data.page >= data.pages} onClick={() => setF({ ...f, page: f.page + 1 })} data-testid="admin-feedbacks-next">Suivant</Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
